import type { MediaType } from '@teaplus/shared';
import { lastStream } from './store';

/**
 * What this window is playing right now, set by the watch page while its player is on screen.
 * Accepting a friend's Request to Join reads it to turn the film into a party where it is,
 * without restarting the stream.
 */
export interface NowPlaying {
  type: MediaType;
  id: string;
  season: number | null;
  episode: number | null;
  title: string;
  posterUrl: string | null;
  year: number | null;
  episodeTitle: string | null;
  inParty: boolean;
  position: () => number;
  duration: () => number;
  playing: () => boolean;
  /** Puts the open player into the party, keeping its stream and position. */
  joinParty: (code: string) => void;
}

let current: NowPlaying | null = null;

export function setNowPlaying(n: NowPlaying) {
  current = n;
  return () => {
    if (current === n) current = null;
  };
}

export const nowPlaying = () => current;

/** The stream the host picked, as party guests match it (see streamKey in the stream chooser). */
export function hostStreamOf(n: NowPlaying) {
  const last = lastStream.get(n.id, n.season ?? undefined, n.episode ?? undefined);
  if (!last) return undefined;
  const key = last.fingerprint.split('|').slice(1).join('|').trim();
  return key ? { fingerprint: key, title: last.label.slice(0, 300) } : undefined;
}
